<gl-base-modal (closeModal)="onClose()">
  <h2 class="title">{{ 'save_project_header' | translate }}</h2>
  <p class="info">{{ 'save_project_message' | translate }}</p>
  <form [formGroup]="form" (ngSubmit)="saveProject()" autocomplete="off">
    <label class="nameLabel">{{ 'project_name' | translate }}</label>
    <gl-input-container>
      <input
        autocomplete="off"
        type="text"
        normal-input
        formControlName="projectTitle"
        name="projectTitle"
      />
    </gl-input-container>
    <p class="projectDescription">{{ projectDescription }}</p>
    <div class="textarea-wrapper">
      <div class="projectNotes">{{ 'project_notes' | translate }}:</div>
      <textarea
        class="textarea"
        formControlName="note"
        maxlength="500"
        autocomplete="off"
        name="projectNote"
      ></textarea>
    </div>
    <div class="checkbox">
      <gl-checkbox
        [(ngModel)]="isCompanyShared"
        [ngModelOptions]="{ standalone: true }"
        [defaultChecked]="true"

      >{{ 'share_within_company' | translate }}</gl-checkbox>
    </div>
    <div class="buttons">
      <button normal-outline-button type="submit">
        {{ 'save_project' | translate }}
      </button>
    </div>
  </form>
</gl-base-modal>
